module.exports = __webpack_public_path__ + "img/ibdpro-logo.7d58103e.svg";